// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".timer__timer___FXKKq{display:flex;align-items:center;font-size:.8571rem;width:100%}", "",{"version":3,"sources":["webpack://./src/component/timer/timer.css"],"names":[],"mappings":"AAMA,sBACC,YAAA,CAAc,kBAAA,CACM,kBAAA,CACC,UACT","sourcesContent":["@import \"cd-ui-react/style/variables.css\";\n\n/**\n\tCSS to be used for default styling of timer.\n*/\n\n.timer {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 0.8571rem;\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timer": "timer__timer___FXKKq"
};
export default ___CSS_LOADER_EXPORT___;
